import { createSelector } from 'reselect';
import { createReducer, INITIAL_STATE } from '../../../shared/redux';
import { buildGetStatesApi, buildGetCitiesApi } from './ibge.api';
import { LOAD_STATE } from '../../../shared/axios';
import { alphabeticallySort } from './ibge.utils';

export const GET_IBGE_STATES = '@billing/ibge/GET_IBGE_STATES';

export const GET_IBGE_STATES_REQUEST_CALLED = '@billing/ibge/GET_IBGE_STATES_REQUEST_CALLED';
export const GET_IBGE_STATES_REQUEST_SUCCEEDED = '@billing/ibge/GET_IBGE_STATES_REQUEST_SUCCEEDED';
export const GET_IBGE_STATES_REQUEST_FAILED = '@billing/ibge/GET_IBGE_STATES_REQUEST_FAILED';

export const GET_IBGE_CITIES_REQUEST_CALLED = '@billing/ibge/GET_IBGE_CITIES_REQUEST_CALLED';
export const GET_IBGE_CITIES_REQUEST_SUCCEEDED = '@billing/ibge/GET_IBGE_CITIES_REQUEST_SUCCEEDED';
export const GET_IBGE_CITIES_REQUEST_FAILED = '@billing/ibge/GET_IBGE_CITIES_REQUEST_FAILED';

export const getIbgeStatesData = state => state.billing.ibge.states.data;
export const getIbgeStatesLoadState = state => state.billing.ibge.states.loadState;

export const getIbgeCitiesData = state => state.billing.ibge.cities.data;
export const getIbgeCitiesLoadState = state => state.billing.ibge.cities.loadState;

export const getIbgeStatesSelector = createSelector([
    getIbgeStatesData,
], ibgeStates => ibgeStates.sort(alphabeticallySort));

export const getIbgeCitiesSelector = createSelector([
    getIbgeCitiesData,
], ibgeCities => ibgeCities.sort(alphabeticallySort));

export const getIbgeCities = uf => ({
    type: GET_IBGE_CITIES_REQUEST_CALLED,
    actionTypes: {
        success: GET_IBGE_CITIES_REQUEST_SUCCEEDED,
        fail: GET_IBGE_CITIES_REQUEST_FAILED,
    },
    config: buildGetCitiesApi(uf),
});

export const getIbgeStates = () => ({
    type: GET_IBGE_STATES,
    payload: {},
});

export const getIbgeStatesRequest = () => ({
    type: GET_IBGE_STATES_REQUEST_CALLED,
    actionTypes: {
        success: GET_IBGE_STATES_REQUEST_SUCCEEDED,
        fail: GET_IBGE_STATES_REQUEST_FAILED,
    },
    config: buildGetStatesApi(),
});

const initialState = {
    states: {
        loadState: LOAD_STATE.LOADING,
        data: [],
        error: null,
    },
    cities: {
        loadState: LOAD_STATE.SUCCESS,
        data: [],
        error: null,
    },
};

export const ibgeReducers = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_IBGE_STATES_REQUEST_CALLED]: state => ({
        ...state,
        states: {
            data: [],
            error: null,
            loadState: LOAD_STATE.LOADING,
        },
    }),
    [GET_IBGE_STATES_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        states: {
            data: action.payload.data,
            loadState: LOAD_STATE.SUCCESS,
            error: null,
        },
    }),
    [GET_IBGE_STATES_REQUEST_FAILED]: (state, action) => ({
        ...state,
        states: {
            data: [],
            loadState: LOAD_STATE.FAIL,
            error: action.payload.data,
        },
    }),
    [GET_IBGE_CITIES_REQUEST_CALLED]: state => ({
        ...state,
        cities: {
            data: [],
            loadState: LOAD_STATE.LOADING,
            error: null,
        },
    }),
    [GET_IBGE_CITIES_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        cities: {
            data: action.payload.data,
            loadState: LOAD_STATE.SUCCESS,
            error: null,
        },
    }),
    [GET_IBGE_CITIES_REQUEST_FAILED]: (state, action) => ({
        ...state,
        cities: {
            data: [],
            loadState: LOAD_STATE.FAIL,
            error: action.payload.data,
        },
    }),
});
